// removed by extract-text-webpack-plugin
module.exports = {"digitalnsw-content":"digitalnsw-content_1He","h1":"h1_3ft","h2":"h2_26L","h3":"h3_vA8","h4":"h4_PtV","h5":"h5_1gY","mainContent":"mainContent_6Yy","row":"row_34E","col60":"col60_2SX","col40":"col40_17Z","col":"col_131","projectsLoadingText":"projectsLoadingText_3Bx","projectsLoadingSpinner":"projectsLoadingSpinner_29J","spinner":"spinner_Up1"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/root/root.scss
// module id = 363
// module chunks = 0 1